import { render, staticRenderFns } from "./status-item.vue?vue&type=template&id=21f28b56&scoped=true&"
import script from "./status-item.vue?vue&type=script&lang=js&"
export * from "./status-item.vue?vue&type=script&lang=js&"
import style0 from "./status-item.vue?vue&type=style&index=0&id=21f28b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f28b56",
  null
  
)

export default component.exports